/**
 * EmailServer Information Column Configuration
 *
 * Uses shared column factory for base columns and config columns.
 */
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import type { TFunction } from 'i18next'
import {
    ServiceDetailRow,
    buildServiceDetailColumns,
} from '@/modules/Service/utils/service-detail'

// ============================================================================
// Column Configuration - Email.EmailServer template
// ============================================================================

export const createEmailServerColumns = (
    t: TFunction,
    rows: ServiceDetailRow[] = []
): DataTableColumn<ServiceDetailRow>[] => {
    return buildServiceDetailColumns({
        t,
        rows,
        customConfigs: [
            {
                key: 'account',
                title: t('mail-account'),
                configName: ['account', 'mail-account'],
                width: 100,
            },
            {
                key: 'storage',
                title: t('email-storage'),
                configName: 'storage',
                width: 100,
            },
            {
                key: 'attachment',
                title: t('email-attachment'),
                configName: 'email-attachment',
                width: 100,
            },
            {
                key: 'addon_domain',
                title: t('addon-domain'),
                configName: 'addon-domain',
                width: 120,
            },
        ],
    })
}
